@if (dataIsLoaded) {
  <div class="news-list-container">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="#/zhs-CN/home" [innerHTML]="navData.navText1"></a></li>
      <li class="breadcrumb-item active" aria-current="page" [innerHTML]="navData.navText2"></li>
    </ol>
    <div class="container">
      <div class="news-title">
        <h2 [innerHTML]="data.title"></h2>
        @if (data.text) {
          <p [innerHTML]="data.text"></p>
        }
      </div>
      <div class="row">
        @for (item of curDataes; track item; let i = $index) {
          <div class="col-md-4">
            <div class="news-content">
              <div class="news-image">
                <a href="javaScript:void(0);" (click)="toDetails(item.id)">
                  <img class="w-100" [src]="item.imgUrl" alt="img" />
                </a>
              </div>
              <div class="news-info">
                <p [innerHTML]="item.heading"></p>
                <div class="news-detail">
                  <span [innerHTML]="item.timeText"></span>
                  <a href="javaScript:void(0);" (click)="toDetails(item.id)" [innerHTML]="item.linkText"></a>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <!-- pagination -->
    <div class="news-pagination d-flex justify-content-center">
      <u-pagination
        [(currentPageIndex)]="curPage"
        [pageIndexes]="pageIndexes"
        (currentPageIndexChange)="pageChange($event)"
        [maxItemSize]="maxSize"
      >
      </u-pagination>
      @if (!isWebOrMobile()) {
        <span [innerHTML]="pageInfo"></span>
      }
    </div>
  </div>
}
